
import { useState, useEffect, ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface AuthModeHandlerProps {
  children: (authMode: "login" | "signup" | "forgotPassword" | "resetPassword", setAuthMode: (mode: "login" | "signup" | "forgotPassword" | "resetPassword") => void) => ReactNode;
}

export const AuthModeHandler = ({ children }: AuthModeHandlerProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const authModeParam = searchParams.get("mode");
  const tabParam = searchParams.get("tab");
  const typeParam = searchParams.get("type");
  
  // Check for Supabase password reset parameters
  const hasHashParams = location.hash.includes('access_token') && location.hash.includes('type=recovery');
  const isPasswordReset = typeParam === "recovery" || authModeParam === "resetPassword" || hasHashParams;

  // Only set initial mode from URL, never update URL from tab switch
  const [authMode, setAuthMode] = useState<"login" | "signup" | "forgotPassword" | "resetPassword">(() => {
    if (isPasswordReset) return "resetPassword";
    if (authModeParam === "signup" || tabParam === "signup") return "signup";
    if (tabParam === "login") return "login";
    return "login";
  });

  // If the URL changes (user navigates from outside), update the mode
  useEffect(() => {
    const hasHashParams = location.hash.includes('access_token') && location.hash.includes('type=recovery');
    const isPasswordReset = typeParam === "recovery" || authModeParam === "resetPassword" || hasHashParams;
    
    if (isPasswordReset) setAuthMode("resetPassword");
    else if (authModeParam === "signup" || tabParam === "signup") setAuthMode("signup");
    else if (tabParam === "login") setAuthMode("login");
  }, [typeParam, authModeParam, tabParam, location.hash]);

  return <>{children(authMode, setAuthMode)}</>;
};
